import { MyAppList } from '@/services/application'

const state = {
  applicationList: [],
  pagination: {
    page: 1,
    pageSize: 12,
    count: 0
  }
}

const mutations = {
  updateApplicationList(state, { payload }) {
    state.applicationList = payload.list
    state.pagination = {
      page: payload.page,
      pageSize: 12,
      count: payload.count
    }
  }
}

const actions = {
  async fetchApplicationList({ commit, state }, payload) {
    const response = await MyAppList(payload)
    if (response && response.code === '0') {
      commit({ type: 'updateApplicationList', payload: response.data })
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/myApplication.js